module.exports = __webpack_public_path__ + "static/media/z_praxe_aromaterapeuta.4f309954.svg";